import { CardType } from '../types';
import type { CardData, CardDataProvider } from '../types';

const getStatusCountData = (params: Parameters<CardDataProvider>[0] | undefined, statusKey: string): CardData => {
  const { statusCountMap } = params ?? {};
  const isLoading = statusCountMap == null;
  const value = isLoading ? null : (statusCountMap[statusKey] ?? 0);

  return { value, isLoading };
};

export const getAwaitingShipmentData: CardDataProvider = (params) => getStatusCountData(params, 'AwaitingShipment');

export const getOnHoldData: CardDataProvider = (params) => getStatusCountData(params, 'OnHold');

export const getPendingPaymentData: CardDataProvider = (params) => getStatusCountData(params, 'AwaitingPayment');

export const getRejectedFulfillmentData: CardDataProvider = (params) => getStatusCountData(params, 'RejectedFulfillment');

export const getUnshippedLast7Days = (value: number | null): CardData => {
  const isLoading = value === null;

  return { value, isLoading };
};

export const getShippedTodayData = (value: number | null): CardData => {
  const isLoading = value === null;

  return { value, isLoading };
};

export const getPendingReturnsData = (value: number | null): CardData => {
  const isLoading = value === null;

  return { value, isLoading };
};

export const getYesterdayUnshippedData = (value: number | null): CardData => {
  const isLoading = value === null;

  return { value, isLoading };
};

export const getAgingOrders7To30Data = (value: number | null): CardData => {
  const isLoading = value === null;

  return { value, isLoading };
};

export const getCardData = (
  cardType: CardType,
  params: Parameters<CardDataProvider>[0] | null,
  asyncValues?: {
    yesterdayUnshipped?: number | null;
    oldestUnshipped?: number | null;
    shippedToday?: number | null;
    pendingReturns?: number | null;
    agingOrders7To30?: number | null;
  },
): CardData => {
  if (!params) {
    return { value: null, isLoading: true };
  }
  switch (cardType) {
    case CardType.AWAITING_SHIPMENT:
      return getAwaitingShipmentData(params);
    case CardType.UNSHIPPED_LAST_7_DAYS:
      return getUnshippedLast7Days(asyncValues?.oldestUnshipped ?? null);
    case CardType.SHIPPED_TODAY:
      return getShippedTodayData(asyncValues?.shippedToday ?? null);
    case CardType.PENDING_RETURNS:
      return getPendingReturnsData(asyncValues?.pendingReturns ?? null);
    case CardType.ON_HOLD:
      return getOnHoldData(params);
    case CardType.PENDING_PAYMENT:
      return getPendingPaymentData(params);
    case CardType.REJECTED_FULFILLMENT:
      return getRejectedFulfillmentData(params);
    case CardType.YESTERDAY_UNSHIPPED:
      return getYesterdayUnshippedData(asyncValues?.yesterdayUnshipped ?? null);
    case CardType.AGING_ORDERS_7_TO_30_DAYS:
      return getAgingOrders7To30Data(asyncValues?.agingOrders7To30 ?? null);
    default:
      return { value: null, isLoading: true };
  }
};
